import { render, staticRenderFns } from "./webapp_modal.vue?vue&type=template&id=11052b94&"
import script from "./webapp_modal.vue?vue&type=script&lang=js&"
export * from "./webapp_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports